import Axios from "axios";

const api = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { "X-Tenant-ID": process.env.VUE_APP_X_TENANT_ID },
  timeout: 0,
});

// interceptor
api.interceptors.response.use(
  (res) => Promise.resolve(res),
  (err) => Promise.resolve(err.response?.data || err.response)
);

export default api;
